import {
  NotificationCursorPage,
  NotificationFetchParams,
  ProviderNotificationSummary,
} from "@/types/notification";

import { requestData } from "@/api/api-config";

export async function fetchNotifications(
  filters: NotificationFetchParams = {},
): Promise<NotificationCursorPage | null> {
  // Build search params, filtering out null/undefined values
  const searchParams: Record<string, unknown> = { ...filters };
  for (const key of Object.keys(searchParams)) {
    if (searchParams[key] === null || searchParams[key] === undefined) {
      delete searchParams[key];
    }
  }

  return await requestData<NotificationCursorPage>(
    "notifications",
    "get",
    {
      searchParams,
    },
    false,
  );
}

/** The notifications combined into a stacked row, newest first. */
export async function fetchCombinedNotifications(
  notificationId: string,
): Promise<ProviderNotificationSummary[] | null> {
  return await requestData<ProviderNotificationSummary[]>(
    `notifications/${notificationId}/combined`,
    "get",
    {},
    false,
  );
}

export async function markNotificationsRead(
  notificationIds: string[],
): Promise<{ updated: number } | null> {
  return await requestData<{ updated: number }>(
    "notifications/mark-read",
    "post",
    {
      json: { notification_ids: notificationIds },
    },
    false,
  );
}

export async function markNotificationsUnread(
  notificationIds: string[],
): Promise<{ updated: number } | null> {
  return await requestData<{ updated: number }>(
    "notifications/mark-unread",
    "post",
    {
      json: { notification_ids: notificationIds },
    },
    false,
  );
}

export async function archiveNotifications(
  notificationIds: string[],
): Promise<{ updated: number } | null> {
  return await requestData<{ updated: number }>(
    "notifications/archive",
    "post",
    {
      json: { notification_ids: notificationIds },
    },
    false,
  );
}

export type BulkNotificationAction =
  | "mark_all_read"
  | "archive_all"
  | "archive_read";

export async function bulkNotificationAction(
  action: BulkNotificationAction,
): Promise<{ updated: number } | null> {
  return await requestData<{ updated: number }>(
    "notifications/bulk-action",
    "post",
    {
      json: { action },
    },
    false,
  );
}
